<template>
  <button
    type="button"
    class="bar"
    :class="{
      'cont-before': segment.continuesBefore,
      'cont-after': segment.continuesAfter,
      active
    }"
    :style="{
      gridColumn: `${segment.startCol + 1} / ${segment.endCol + 2}`,
      gridRow: segment.lane + 2
    }"
    :title="segment.event.title"
    @click.stop="$emit('select', segment.event, $event.currentTarget)"
  >
    <span class="bar-title">{{ segment.event.title }}</span>
  </button>
</template>

<script>
export default {
  name: "Appointment",
  props: {
    segment: {
      type: Object,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.bar {
  pointer-events: auto;
  display: block;
  min-width: 0;
  margin: 0 3px 3px;
  padding: 4px 0.5rem;
  border: 0;
  border-radius: 4px;
  background: #ffc100;
  color: #333;
  font-size: 0.8rem;
  line-height: 1.3;
  text-align: left;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
  transition: filter 0.15s;
  &:hover,
  &.active {
    filter: brightness(0.92);
  }
  &:focus-visible {
    outline: 2px solid var(--primary);
    outline-offset: 1px;
  }
  &.cont-before {
    margin-left: 0;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  &.cont-after {
    margin-right: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
}
.bar-title {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media screen and (max-width: 575.98px) {
  .bar {
    height: 6px;
    margin-bottom: 2px;
    padding: 0;
    border-radius: 3px;
    box-shadow: none;
  }
  .bar-title {
    display: none;
  }
}
</style>
